import { FunctionComponent } from "react";

interface BatteryProps {}

const Battery: FunctionComponent<BatteryProps> = () => {
  return (
    <div className="mx-auto mt-[85px] flex w-full flex-col items-start justify-start gap-2 px-4 lg:w-1/3 lg:px-0">
      <div className="font-GeistBold text-left text-3xl">
        <h1>Hinweise zur Batterieentsorgung</h1>
      </div>

      <hr className="mb-4 h-[1px] w-full bg-slate-300" />

      <div className="flex flex-col items-start justify-center gap-4 text-base">
        <p>
          Im Zusammenhang mit dem Vertrieb von Batterien oder mit der Lieferung
          von Geräten, die Batterien enthalten, sind wir verpflichtet, Sie auf
          Folgendes hinzuweisen:
        </p>

        <p className="font-GeistBold">
          Batterien dürfen nicht im Hausmüll entsorgt werden.
        </p>

        <p>
          Altbatterien, die wir als Neubatterien im Sortiment führen oder
          geführt haben, nehmen wir unentgeltlich zurück. Sie können sie in
          unseren Geschäften in Reichenbach und Plauen abgeben oder ausreichend
          frankiert an uns senden:
        </p>

        <address className="not-italic">
          Juwelier Bucher GbR
          <br />
          Weinholdstraße 33
          <br />
          08468 Reichenbach
        </address>

        <p>
          Alternativ können Sie die Batterien an den örtlichen Sammelstellen
          abgeben.
        </p>

        <p>
          Viele unserer Uhren enthalten eine Knopfzelle. Sie können diese
          Batterien nach Gebrauch bei uns abgeben. Gern wechseln wir die
          Batterie Ihrer Uhr auch in unserer Werkstatt und entsorgen die alte
          fachgerecht.
        </p>

        <p>
          Sie sind zur Rückgabe gebrauchter Batterien als Endnutzer gesetzlich
          verpflichtet, damit die Batterien wiederaufbereitet oder fachgerecht
          entsorgt werden können.
        </p>

        <p>
          Altbatterien können Schadstoffe enthalten, die bei nicht sachgemäßer
          Lagerung oder Entsorgung die Umwelt oder Ihre Gesundheit schädigen
          können. Batterien enthalten aber auch wichtige Rohstoffe, wie z. B.
          Eisen, Zink, Mangan oder Nickel, und können verwertet werden.
        </p>

        <p>
          Die auf den Batterien abgebildeten Symbole haben folgende Bedeutung:
        </p>

        <p>
          Das Symbol der durchgekreuzten Mülltonne bedeutet, dass die Batterie
          nicht in den Hausmüll gegeben werden darf.
        </p>

        <p>
          Bei Batterien, die eine bestimmte Masse an Blei, Cadmium oder
          Quecksilber enthalten, wird durch die nachfolgenden Zusätze unter dem
          Symbol mit der durchgestrichenen Mülltonne auf die jeweiligen
          Schadstoffe hingewiesen:
        </p>

        <ul className="list-disc space-y-1 pl-6">
          <li>
            <strong>Pb</strong> = Batterie enthält mehr als 0,004 Masseprozent
            Blei
          </li>
          <li>
            <strong>Cd</strong> = Batterie enthält mehr als 0,002 Masseprozent
            Cadmium
          </li>
          <li>
            <strong>Hg</strong> = Batterie enthält mehr als 0,0005 Masseprozent
            Quecksilber
          </li>
        </ul>

        <p>
          Informationen zu den enthaltenen Kosten gemäß Artikel 56 Absatz 4
          EU-Batterieverordnung (Verordnung 2023/1542) finden Sie bei der
          Initiative{" "}
          <a
            href="https://www.batterie-zurueck.de/de/bewirtschaftungvonaltbatterien/"
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-2"
          >
            Batterie-Zurück
          </a>
          .
        </p>

        <p>Bitte beachten Sie die vorstehenden Hinweise.</p>
      </div>
    </div>
  );
};

export default Battery;
